<template>
  <div class="xh-wrap">
    <!-- <page-top></page-top> -->
    <myImg
      img="https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/banner_5_1.png"
    ></myImg>
    <myTab
      :tab-list="tabList"
      @change="changeTab"
      smallSize
      :activeIndex="activeIndex"
      :bread-title="breadTitle"
    ></myTab>
    <template v-if="activeIndex == 3">
      <div class="container mt-50">
        <div class="mb-20 flex-container-row" v-for="(v, i) in menuList" :key="i">
          <a class="bold item-title mr-20 color-fff fs-20 flex-container nav_title" @click="toNav(v)">
            <span>{{ v.title }}</span>
            <span>{{v.en}}</span>
          </a>
          <template v-if="v.subMenu.length">
            <div class="flex-container-row_wrap">
              <a
              class="item-subTitle mr-20  color-fff fs-20 flex-container"
              v-for="(sv, si) in v.subMenu"
              :key="si"
              @click="toSubUrl(v, sv, si)"
              >
              <span>{{ sv.subTitle }}</span>
              <span>{{sv.en}}</span>
              </a
            >
            </div>
            
          </template>
        </div>
      </div>
    </template>
    <template v-if="activeIndex == 1">
      <div class="container">
        <div class="color-fff fs-20 mt-50 mb-50" stlye="text-indent:2em;">
          &nbsp; &nbsp;
          &nbsp;&nbsp;本网站包含之所有内容：文本、图形、LOGO、创意、及软件等之所有权归属广州国际汽车展览会组委会，受中国及国际版权法的保护。对本网站上所有内容之复制（意指收集、组合和重新组合），本网站享有排他权并受中国及国际版权法的保护。本网站的特有信息经网站许可方能转载，并需标明出处。
        </div>
      </div>
    </template>
    <template v-if="activeIndex == 2">
      <div class="container text-center color-ccc fs-20">
        <b-container>
          <b-row>
            <b-col
              xs="6"
              sm="6"
              md="4"
              lg="2"
              v-for="(v, i) in linkList"
              :key="i"
            >
              <div class="item mt-40 text-center img_wrap">
                <img v-lazy="v.img" />
                <a href="#" class="fs-16 mt-20">{{ v.title }}</a>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </template>
    <template v-if="activeIndex == 0">
      <div class="container flex-container-row justify-spacebeteen">
        <div class="mb-50 color-fff mt-50 fs-20 lh-custom flex-1">
          <div>广州展联展览服务有限公司</div>
          <div>
            地址：广州市海珠区凤浦中路 669 号广交会大厦 B 座908室
          </div>
          <div>
            <a href="tel:020-89268911">电话：020-89138182</a>
          </div>
          <div>
            <a href="tel:020-89268965">传真：020-89138054</a>
          </div>
          <div>
            <a target="_blank" href="http://www.expounion.com.cn/"
              >网址：www.expounion.com.cn</a
            >
          </div>
        </div>
        <div class="mb-50 color-fff mt-50 fs-20 lh-custom flex-container-col flex-1">
          <div>Guangzhou Zhanlian Exhibition Service Co., Ltd</div>
          <div>
              Address：Room 908, Canton Fair Building B, No. 669 FengpuMiddle Road, HaizhuDistrict, Guangzhou City
          </div>
          <div>
            <a href="tel:020-89268911">Tel：020-89138182</a>
          </div>
          <div>
            <a href="tel:020-89268965">Fax：020-89138054</a>
          </div>
          <div>
            <a target="_blank" href="http://www.expounion.com.cn/"
              >Website：www.expounion.com.cn</a
            >
          </div>
        </div>
      </div>
    </template>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageTop from "@/components/pageTop";
import pageFooter from "@/components/pageFooter";
import myImg from "@/components/myImg";
import myTab from "@/components/myTab";
export default {
  components: {
    pageTop,
    pageFooter,
    myImg,
    myTab,
  },
  data() {
    return {
      tabList: [
        {
          title:"联系我们",
          en:"Contact Us"
        },
        {
          title:"法律声明",
          en:"Announcement"
        },
        {
          title:"友情链接",
          en:"Link"
        },
        {
          title:"网站地图",
          en:"Website Guide"
        }
      ],
      activeIndex: 0,
      breadTitle: {
        cn: "辅助栏目",
        en: "Auxiliary",
      },
      //pc端菜单
      menuList: [
        {
          title: "展会指南",
          menuType: "1",
          en: "Information",
          subMenu: [
            {
              subTitle: "展会介绍",
              url: "/schedule?tab=0",
              en: "Exhibition",
            },
            {
              subTitle: "日程安排",
              url: "/schedule?tab=1",
              en: "Schedule",
            },
            {
              subTitle: "交通指南",
              url: "/schedule?tab=2",
              en: "Transportation",
            },
            {
              subTitle: "展位图",
              url: "/schedule?tab=3",
              en: "Pavilion",
            },
            {
              subTitle: "购票方式",
              url: "/schedule?tab=4",
              en: "Ticket",
            },
            {
              subTitle: "酒店住宿",
              url: "/schedule?tab=5",
              en: "Hotel",
            },
          ],
        },
        {
          title: "新闻中心",
          menuType: "1",
          en: "News Center",
          subMenu: [
            {
              subTitle: "展会公告",
              url: "/newsCenter?tab=0",
              en: "Notice",
            },
            {
              subTitle: "展会新闻",
              url: "/newsCenter?tab=1",
              en: "News",
            },
            // {
            //   subTitle: "防控指引",
            //   url: "/newsCenter?tab=2",
            // },
          ],
        },
        {
          title: "展商",
          menuType: "1",
          en: "Exhibitor",
          subMenu: [
            {
              subTitle: "招展函",
              url: "/exhibitor?tab=0",
              en: "Invitation",
            },
            {
              subTitle: "主场服务",
              url: "/exhibitor?tab=1",
              en: "Service",
            },
            {
              subTitle: "展商手册",
              url: "/exhibitor?tab=2",
              en: "Exhibitor's Manual",
            },
            {
              subTitle: "展位图",
              url: "/exhibitor?tab=3",
              en: "Pavilion",
            },
            {
              subTitle: "资料下载",
              url: "/exhibitor?tab=4",
              en: "Download",
            },
          ],
        },
        {
          title: "票务信息",
          menuType: "1",
          en: "Ticket",
          subMenu: [
            {
              subTitle: "在线售票",
              url: "/buyTicket?tab=0",
              en: "Online Ticket",
            },
            {
              subTitle: "购票须知",
              url: "/buyTicket?tab=1",
              en: "Notice",
            },
          ],
        },
        {
          title: "媒体",
          menuType: "1",
          en: "Media",
          subMenu: [
            {
              subTitle: "媒体合作",
              url: "/mediaCenter?tab=0",
              en: "Cooperation",
            },
            {
              subTitle: "媒体证申请",
              url: "/mediaCenter?tab=1",
              en: "Application",
            },
          ],
        },
        // {
        //   title: "关于我们",
        //   menuType: "1",
        //   subMenu: [
        //     {
        //       subTitle: "联系我们",
        //       url: "/aboutUs?tab=0"
        //     },
        //     {
        //       subTitle: "参展须知",
        //       url: "/aboutUs?tab=1"
        //     }
        //   ]
        // },
        {
          title: "活动",
          menuType: "1",
          en: "Activities",
          subMenu: [
            {
              subTitle: "新闻发布会",
              url: "/activity?tab=0",
              en: "Press Conference",
            },
            {
              subTitle: "同期活动",
              url: "/activity?tab=1",
              en: "Meetings&",
            },
          ],
        },
        {
          title: "历届回顾",
          menuType: "1",
          en: "Review",
          subMenu: [
            {
              subTitle: "图片",
              url: "/history?tab=0",
              en: "Photo",
            }
            // {
            //   subTitle: "视频",
            //   url: "/history?tab=1",
            //   en: "Video",
            // },
          ],
        },
        {
          title: "辅助栏目",
          menuType: "2",
          en: "Auxiliary",
          subMenu: [
          {
              subTitle: "联系我们",
              url: "/history?tab=1",
              en: "Contact Us",
            },
            {
              subTitle: "法律声明",
              url: "/history?tab=1",
              en: "Announcement",
            },
            {
              subTitle: "友情链接",
              url: "/history?tab=1",
              en: "Link",
            },
            {
              subTitle: "网站地图",
              url: "/history?tab=0",
              en: "Website Guide",
            },
          ],
        },
      ],
      linkList: [
      {
          id: "256",
          img:"https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link256.jpg",
          title:"热点科技"
        },
      {
          img:"https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link252.png",
          title:"中国日报"
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link1.jpg",
          title: "网上汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link2.jpg",
          title: "CENS",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link3.jpg",
          title: "环球汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link4.jpg",
          title: "怡和汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link5.jpg",
          title: "盖世汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link6.jpg",
          title: "壹馬",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link7.jpg",
          title: "中国汽配商讯网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link8.jpg",
          title: "汽车电器",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link9.jpg",
          title: "中国汽车供应商网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link10.jpg",
          title: "汽车零部件",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link11.jpg",
          title: "南方日报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link12.jpg",
          title: "汽车公社",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link13.jpg",
          title: "优车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link14.jpg",
          title: "车问",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link15.jpg",
          title: "国际在线",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link16.jpg",
          title: "央广网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link17.jpg",
          title: "车迷之家",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link18.jpg",
          title: "搜狐汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link19.jpg",
          title: "中华网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link20.jpg",
          title: "汽车自驾游",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link21.jpg",
          title: "汽车杂志",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link22.jpg",
          title: "汽车配件商讯",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link23.jpg",
          title: "润滑油情报网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link24.jpg",
          title: "车神榜",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link25.jpg",
          title: "海淘车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link26.jpg",
          title: "汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link27.jpg",
          title: "广州摄影网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link28.jpg",
          title: "新能源汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link29.jpg",
          title: "汽车观察杂志",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link30.jpg",
          title: "车主之家",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link31.jpg",
          title: "芒果tv",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link32.jpg",
          title: "爱奇艺",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link33.jpg",
          title: "360",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link34.jpg",
          title: "每日汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link35.jpg",
          title: "合",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link36.jpg",
          title: "优酷",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link37.jpg",
          title: "土豆",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link38.jpg",
          title: "车惠",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link39.jpg",
          title: "寰球汽车传媒",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link40.jpg",
          title: "中国买车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link41.jpg",
          title: "中国新能源汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link42.jpg",
          title: "汽车研究院",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link43.jpg",
          title: "汽车与新动力",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link44.jpg",
          title: "汽车之家",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link45.jpg",
          title: "YOURCHE",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link46.jpg",
          title: "驱动汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link47.jpg",
          title: "正直播",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link48.jpg",
          title: "智驾",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link49.jpg",
          title: "中工网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link50.jpg",
          title: "中国节能与新能源汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link51.jpg",
          title: "中国经营报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link52.jpg",
          title: "中国汽车消费网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link53.jpg",
          title: "酷划在线",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link54.jpg",
          title: "商用车界",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link55.jpg",
          title: "汽车维修与保养",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link56.jpg",
          title: "中华汽配网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link57.jpg",
          title: "中国汽车供应商网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link58.jpg",
          title: "国际汽车设计及制造",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link59.jpg",
          title: "汽配网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link60.jpg",
          title: "汽配工业网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link61.jpg",
          title: "慧聪网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link62.jpg",
          title: "慧聪汽车配件网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link63.jpg",
          title: "王球汽配采购网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link64.jpg",
          title: "汽车电器",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link65.jpg",
          title: "汽车用品报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link66.jpg",
          title: "宜配网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link67.jpg",
          title: "中国汽车动态网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link68.jpg",
          title: "中国汽车咨询中心网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link69.jpg",
          title: "中国汽配城",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link70.jpg",
          title: "AI汽车制造业",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link71.jpg",
          title: "Sensata Technologies",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link72.jpg",
          title: "秀配网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link73.jpg",
          title: "中国汽车配件网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link74.jpg",
          title: "汽车维修与保养",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link75.jpg",
          title: "盖世汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link76.jpg",
          title: "AI汽车制造业",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link77.jpg",
          title: "悲馬广告",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link78.jpg",
          title: "中国汽车咨询中心网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link79.jpg",
          title: "汽车与驾驶维修",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link80.jpg",
          title: "宜配网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link81.jpg",
          title: "Ringier",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link82.jpg",
          title: "改装与四驱",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link83.jpg",
          title: "汽车导报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link84.jpg",
          title: "中国赛车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link85.jpg",
          title: "网易",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link86.jpg",
          title: "网易汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link87.jpg",
          title: "环球汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link88.jpg",
          title: "环球时报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link89.jpg",
          title: "汽车画报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link90.jpg",
          title: "车道",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link91.jpg",
          title: "车生活网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link92.jpg",
          title: "汽车测试报告",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link93.jpg",
          title: "汽车店铺",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link94.jpg",
          title: "21CN.com",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link95.jpg",
          title: "汽车商业评论",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link96.jpg",
          title: "汽车消费报告",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link97.jpg",
          title: "汽车用品报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link98.jpg",
          title: "快车道",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link99.jpg",
          title: "梅卿快车道",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link100.jpg",
          title: "轿车情报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link101.jpg",
          title: "汽车与配件",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link102.jpg",
          title: "汽车维修",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link103.jpg",
          title: "钢联咨讯",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link104.jpg",
          title: "CASIS",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link105.jpg",
          title: "我的钢铁",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link106.jpg",
          title: "搜狐汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link107.jpg",
          title: "网上车市",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link108.jpg",
          title: "网上汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link109.jpg",
          title: "汽车配件与汽车用品",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link110.jpg",
          title: "OK便利店",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link111.jpg",
          title: "7-Eleven",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link112.jpg",
          title: "全家 FamilyMart",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link113.jpg",
          title: "7-magic",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link114.jpg",
          title: "天天洗衣",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link115.jpg",
          title: "大公网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link116.jpg",
          title: "国际在线",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link117.jpg",
          title: "汽车制造",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link118.jpg",
          title: "中国车展信息网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link119.jpg",
          title: "51汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link120.jpg",
          title: "CRJ",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link121.jpg",
          title: "财米网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link122.jpg",
          title: "财经国家",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link123.jpg",
          title: "车悦网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link124.jpg",
          title: "人民网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link125.jpg",
          title: "汽车博览",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link126.jpg",
          title: "汽车大世界",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link127.jpg",
          title: "上品",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link128.jpg",
          title: "尚悠网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link129.jpg",
          title: "氏族",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link130.jpg",
          title: "腾讯汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link131.jpg",
          title: "羊城网报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link132.jpg",
          title: "羊城交通台",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link133.jpg",
          title: "投资与理财",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link134.jpg",
          title: "汽车之友",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link135.jpg",
          title: "中奢网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link136.jpg",
          title: "车迷",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link137.jpg",
          title: "东方汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link138.jpg",
          title: "轿车情报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link139.jpg",
          title: "快车道",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link140.jpg",
          title: "经济观察报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link141.jpg",
          title: "联合越野",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link142.jpg",
          title: "汽车族",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link143.jpg",
          title: "凤凰网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link144.jpg",
          title: "新浪网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link145.jpg",
          title: "华视传媒",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link146.jpg",
          title: "汽车与运动",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link147.jpg",
          title: "中国国际展览贸易网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link148.jpg",
          title: "nextcar",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link149.jpg",
          title: "5100",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link150.jpg",
          title: "中演票务通",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link151.jpg",
          title: "大麦",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link152.jpg",
          title: "永乐票务",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link153.jpg",
          title: "汽车零部件",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link154.jpg",
          title: "广东电视台汽车会展频道",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link155.jpg",
          title: "生活元素",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link156.jpg",
          title: "21世纪经济报道",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link157.jpg",
          title: "人物周刊",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link158.jpg",
          title: "国际先驱导报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link159.jpg",
          title: "型车志",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link160.jpg",
          title: "广州交通电台",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link161.jpg",
          title: "汽车纵横",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link162.jpg",
          title: "太平洋汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link163.jpg",
          title: "南方网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link164.jpg",
          title: "车唯网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link165.jpg",
          title: "车夫网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link166.jpg",
          title: "家用汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link167.jpg",
          title: "每日经济新闻",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link168.jpg",
          title: "品牌汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link169.jpg",
          title: "企业观察报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link170.jpg",
          title: "汽车经销商",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link171.jpg",
          title: "汽车探索",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link172.jpg",
          title: "汽车与你",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link173.jpg",
          title: "汽车生活",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link174.jpg",
          title: "新车评网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link175.jpg",
          title: "牛车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link176.jpg",
          title: "人民网汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link177.jpg",
          title: "汽车时代网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link178.jpg",
          title: "汽车纵横",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link179.jpg",
          title: "时代周报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link180.jpg",
          title: "太平洋汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link181.jpg",
          title: "中国汽车销售图册",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link182.jpg",
          title: "网上车市",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link183.jpg",
          title: "网易汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link184.jpg",
          title: "中国suv网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link185.jpg",
          title: "汽车经济网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link186.jpg",
          title: "新车评",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link187.jpg",
          title: "新浪汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link188.jpg",
          title: "央广汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link189.jpg",
          title: "越野e族",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link190.jpg",
          title: "兆讯传媒",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link191.jpg",
          title: "中国买车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link192.jpg",
          title: "中国汽车工业信息网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link193.jpg",
          title: "界面新闻",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link194.jpg",
          title: "12缸",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link195.jpg",
          title: "21CN",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link196.jpg",
          title: "58车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link197.jpg",
          title: "yy",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link198.jpg",
          title: "移动咨询软件",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link199.jpg",
          title: "爱卡汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link200.jpg",
          title: "爱买车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link201.jpg",
          title: "爱自驾",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link202.jpg",
          title: "FORTUNE",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link203.jpg",
          title: "车轮",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link204.jpg",
          title: "车靓界",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link205.jpg",
          title: "车讯互联",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link206.jpg",
          title: "车质网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link207.jpg",
          title: "大家车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link208.jpg",
          title: "大圣说车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link209.jpg",
          title: "第1电动",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link210.jpg",
          title: "凤凰网汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link211.jpg",
          title: "大洋网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link212.jpg",
          title: "国游网络",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link213.jpg",
          title: "行天下汽车新媒体",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link214.jpg",
          title: "CRJ",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link215.jpg",
          title: "寰球汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link216.jpg",
          title: "今日车报",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link217.jpg",
          title: "今日头条",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link218.jpg",
          title: "买车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link219.jpg",
          title: "每日汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link220.jpg",
          title: "民生电商汽车频道",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link221.jpg",
          title: "牛车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link222.jpg",
          title: "汽车大全",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link223.jpg",
          title: "汽车公社",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link224.jpg",
          title: "汽车焦点",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link225.jpg",
          title: "汽车经济网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link226.jpg",
          title: "汽车评中评",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link227.jpg",
          title: "汽车头条",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link228.jpg",
          title: "汽车投诉网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link229.jpg",
          title: "汽车网评",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link230.jpg",
          title: "汽车研究网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link231.jpg",
          title: "汽车知识",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link232.jpg",
          title: "汽车族",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link233.jpg",
          title: "人民网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link234.jpg",
          title: "太平洋汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link235.jpg",
          title: "腾讯汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link236.jpg",
          title: "玩车教授",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link237.jpg",
          title: "网上车市",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link238.jpg",
          title: "网通社",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link239.jpg",
          title: "网易汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link240.jpg",
          title: "唯普汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link241.jpg",
          title: "兀卡",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link242.jpg",
          title: "新车评",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link243.jpg",
          title: "新华网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link244.jpg",
          title: "新浪汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link245.jpg",
          title: "一点咨询",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link246.jpg",
          title: "一猫汽车网",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link247.jpg",
          title: "一品汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link248.jpg",
          title: "以上汽车",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link249.jpg",
          title: "优信",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link250.jpg",
          title: "有车以后",
        },
        {
          img:
            "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link251.jpg",
          title: "钛媒体",
        },
        {
          img:"https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link253.png",
          title:"车海洋"
        },
        {
          img:"https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link254.jpg",
          title:"鲸平台"
        },
        {
          img:"https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/friendlyLink/link255.jpg",
          title:"财联社"
        },
      ],
    };
  },
  created() {},
  watch: {},
  methods: {
    toNav(item) {
      if (item.menuType === "2") return;
      let [defaultItem] = item.subMenu;
      let routeData = this.$router.resolve({
        path: defaultItem.url,
      });
      window.open(routeData.href, "_blank");
    },
    toSubUrl(p, item, index) {
      // 特殊跳转
      if (item.url == "/mediaCenter?tab=1") {
        let routeData = this.$router.resolve({
          name: "mediaApply",
        });
        window.open(routeData.href, "_blank");
        return;
      }
      if (p.menuType === "2") {
        this.changeTab(index);
      } else {
        let routeData = this.$router.resolve({
          path: item.url,
        });
        window.open(routeData.href, "_blank");
      }
    },
    changeTab(index) {
      this.activeIndex = index;
      window.scroll(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: #fff;
  cursor: pointer;
  &:hover {
    color: #42abff;
  }
}
.nav_title{
  min-width: 280px;
}



@media screen and (min-width: 100px) and (max-width: 1000px) {
  .empty-tip {
    padding: 300px 0;
  }
  .block-mb {
    margin-bottom: 200px;
  }
  .lh-custom {
    line-height: 120px;
  }
  .nav_title{
    min-width: 380px;
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  .container {
    padding: 0;
  }

  .empty-tip {
    padding: 200px 0;
  }
  .block-mb {
    margin-bottom: 180px;
  }
  .lh-custom {
    line-height: 40px;
  }
  .nav_title{
    min-width: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?2f3d21a8